import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { BehaviorSubject, Subscription, Observable } from 'rxjs';

import { map, pluck } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

declare var require: any;
const FileSaver = require('file-saver');

@Injectable()
export class FilesService {
  option: any;

  constructor(private http: HttpClient) {
    this.option = {
      responseType: 'blob',
    };
  }

  generateExcelPropiedades(filtro: string) {
    this.http
      .get<any>(
        `${environment.url_api}/dashboard/propiedades/exportar/excel?${filtro}`,
        this.option,
      )
      .subscribe(
        (response) => {
          // download file
          FileSaver.saveAs(response, `propiedades`);
        },
        (error) => {
          console.error(`Error: ${error.message}`);
        },
      );
  }

  createBciBankPayrollReport(paymentIds: number[]) {
    this.http
      .post<any>(
        `${environment.url_api}/dashboard/bci-bank-payroll-reports`,
        {
          payment_ids: paymentIds,
        },
        this.option,
      )
      .subscribe(
        (response) => {
          // download file
          FileSaver.saveAs(response, `bci_bank_payroll_report`);
        },
        (error) => {
          console.error(`Error: ${error.message}`);
        },
      );
  }

  generateExcelPaidSubscriptionIvoices() {
    this.http
      .post<any>(
        `${environment.url_api}/dashboard/paid-subscription-invoice-reports`,
        [],
        this.option,
      )
      .subscribe(
        (response) => {
          // download file
          FileSaver.saveAs(response, `paid_subscription_invoices`);
        },
        (error) => {
          console.error(`Error: ${error.message}`);
        },
      );
  }
}
